import { render, staticRenderFns } from "./PercentageChange.vue?vue&type=template&id=64daa917&scoped=true&"
import script from "./PercentageChange.vue?vue&type=script&lang=js&"
export * from "./PercentageChange.vue?vue&type=script&lang=js&"
import style0 from "./PercentageChange.vue?vue&type=style&index=0&id=64daa917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64daa917",
  null
  
)

export default component.exports